<template>
  <div>
    <div id="print_area">
      <div class="card_box" :style="[isBoarder ? {'border-color':getSecondaryColor} : {'border-color':getThemeColor}]">
        <img
          :src="getApiUrl+'/images/logos/'+getUserSchool.emis+'/'+logos[0]"
          style="width:75%;height:100%;opacity:0.2;border-radius:50%"
          class="ml-15 pl-10"
        />
        <div class="content">
          <div class="card_header" :style="[isBoarder ? getInvertedStyle : getThemeStyle]">
            <div style="float: left" class="mr-1">
              <img
                :src="getApiUrl+'/images/logos/'+getUserSchool.emis+'/'+logos[0]"
                width="40"
                height="40"
                style="border-radius:50%"
              />
            </div>
            <div :style="[isBoarder ? getInvertedStyle : getThemeStyle]">
              <div class="font_name">{{ getUserSchool.schname }}</div>
              <b></b>
              <v-icon x-small :style="[isBoarder ? getInvertedStyle : getThemeStyle]">mdi-map-marker</v-icon>
              {{ getUserSchool.physical_address }}
              {{ getUserSchool.city }} {{ getUserSchool.pcode }}
              <br />
              <b></b>
              <v-icon x-small :style="[isBoarder ? getInvertedStyle : getThemeStyle]">mdi-phone</v-icon>
              Phone: {{ getUserSchool.sch_tel }}
            </div>
          </div>

          <div class="id_box_body">
            <v-img
              id="img_card"
              :src="profilePic"
              :lazy-src="lazyLoad"
              class="img-tumb img_card"
              align="right"
            ></v-img>

            <div class="id_title" :style="[isBoarder ? getInvertedStyle : getThemeStyle]">
              STUDENT BIO
            </div>
            <div style="margin-top: 5px;"></div>
            <div class="field">
              <div class="name_field mb-2">
                
                <span class="id_field ml-1 mr-2"><v-icon left :style="[isBoarder ? getInvertedStyle : getThemeStyle]">mdi-account-school</v-icon></span>
                <span class="inf"> {{ student.class }}</span>
              </div>

              <div class="name_field mb-2">
               
                <span class="id_field ml-1 mr-2"><v-icon left :style="[isBoarder ? getInvertedStyle : getThemeStyle]">mdi-identifier</v-icon></span>
                <span class="inf">{{student.sid}} {{isBoarder ? " | Boarder " : (isBoardingSchool ? " | Day Student" : "")}}</span>
              </div>

              <div class="name_field mb-2">
                <span class="id_field ml-1 mr-2"><v-icon left :style="[isBoarder ? getInvertedStyle : getThemeStyle]">mdi-account</v-icon></span>
                <span class="inf">{{ student.gender && student.gender.includes('F') ? 'Female' : "Male" }}</span>
              
              </div>

              <div class="name_field mb-2">
                <span class="id_field ml-1 mr-2"><v-icon left :style="[isBoarder ? getInvertedStyle : getThemeStyle]">mdi-cake-variant</v-icon></span>
                <span class="inf">{{student.dob ? student.dob.split('(')[0] : ""}}</span>
                
              </div>

              <div class="name_field mb-2">
                <span class="id_field ml-1 mr-2"><v-icon left :style="[isBoarder ? getInvertedStyle : getThemeStyle]">mdi-phone</v-icon></span>
                <span class="inf-tel">{{ getEmergencyTel }}</span>
              </div>
              <div class="field1"></div>
            </div>
          </div>

          <div class="card_footer" >
            <center class="barcode_div" :style="[isBoarder ? getInvertedStyle : getThemeStyle]">
              <img :src="'data:image/png;base64,' + studentBarcode" alt="barcode" />
            </center>
          </div>
        </div>
      </div>

      <!-- Front end of id card -->
    </div>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import studentjs from "@/plugins/students"

export default {
  props: ["student"],
  watch: {
    student() {
      this.updateCard();
    }
  },

  computed: {
    getEmergencyTel(tel) {
     return studentjs.getStudentTel(tel)
    },
    isBoarder(){
      if(this.student){
        return this.student.border && this.student.border.includes("es")
      }else{
        return false
      }
      
    },
    isBoardingSchool(){
      const emises = ["500171014","500200836"]
      return emises.includes(this.getUserSchool.emis) 

    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getInvertedStyle() {
      return this.$store.getters.getInvertedStyle;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    }
  },
  mounted() {
    
    this.updateCard();
  },
  data() {
    return {
      studentBarcode: null,
      profilePic: null,
      lazyLoad:null,
      validity: null,
      logos: []
    };
  },
  methods: {
    updateCard() {
      axios
        .postDataWithToken(
          "/auth/get-id-data",
          { student: this.student },
          this.getAccessToken
        )
        .then(idData => {
          this.studentBarcode = idData.barcode;
          this.validity = idData.validity;
          const img =
            this.getApiUrl +
            "/images/students_profile_pics/" +
            this.getUserSchool.emis +
            "/" +
            this.student.sid +
            ".jpeg";

          this.profilePic = img || idData.profilePic;
          this.lazyLoad = this.getApiUrl+'/images/students_profile_pics/def_user_2.png'

          this.getLogos(this.getUserSchool.emis);
        });
    },
    async updateCardStatus(sid) {
      this.$store.commit('setLoader',true)
      const updated = await studentjs.updateCardStatus(sid)

      if (updated) {
        this.$toast.success('Card Status Successfully Updated!', { duration: 3000 })
      } else {
        this.$toast.error('Oops, Something went wrong!',{duration:3000})
      }
      this.$store.commit('setLoader',false)
    },
    getLogos(emis) {
      axios
        .postData("/auth/get-logos-for-given-school", {
          folder: "logos",
          emis: emis
        })
        .then(logos => {
          this.logos = logos;
        });
    }
  },
  filters: {
    normalizeNames(name) {
      let normalizedName = ""
      if(name){
          const names = name.split(" ");
          normalizedName = names[0];
          if(names.length > 1){
            for (let i = 1; i < names.length; i++) {
              normalizedName += " " + names[i].charAt(0) + ".";
            }
          }
      }
      
      return normalizedName;
    }
  }
};
</script>


<style lang="scss" scoped>
.id_card {
  height: auto;
}

.back_details {
  color: black;
  font-family: inherit;
  font-weight: bold;
  text-align: center;
  margin-top: 7px;
}

.back_details_baron {
  color: black;
  font-family: inherit;
  font-size: 12px;
  text-align: center;
  margin-top: 3px;
}

@media print {
  .margin_id_card {
    margin-right: 15px;
  }

  @page {
    size: A4; /* DIN A4 standard, Europe */
    margin: none !important;
    content: counter(page);
  }
}
.img-tumb {
  display: inline-block;
  max-width: 100%;
  height: auto;
  padding: 2px;
  line-height: 1.42857143;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 4px; //4px
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.img_card {
  height: 155px; //165
  width: 115px; //120
  overflow: visible;
  margin-top: 25px;
  margin-right: 2px;
  margin-left: 4px;
  float: left;
}

.box1 {
  height: auto;
  overflow: auto;
  padding: 15px;
  overflow: auto;
  margin-left: 50px;
}

.field1 {
  margin-top: -110px;
  margin-left: 125px;
  background-size: 100% 100%;
  height: 110px;
  width: 120px;

  opacity: 0.1;
}

.card_box {
  position: relative;
  overflow: hidden;
  background: #eeeeee;
  height: 200px;
  width: 99%; //310px

  /* old dims height 260 and width 374 */

  border-radius: 10px;
  border-style: solid;

  /* border-color: #2E363F; */
  border-color: "teal";

  border-width: 4px;
  /* border-width: 4px; */

  float: left;

  margin-bottom: 15px;
  page-break-before: auto; /* 'always,' 'avoid,' 'left,' 'inherit,' or 'right' */
  page-break-after: auto; /* 'always,' 'avoid,' 'left,' 'inherit,' or 'right' */
  page-break-inside: avoid;
}

.content {
  position: absolute; /* Position the background text */
  bottom: 0; /* At the bottom. Use top:0 to append it to the top */
  width: 100%; /* Full width */
}

.card_header {
  /* background-color: #2E363F; */
  background-color: "teal";

  padding: 5px;
  color: #eeeeee;
  height: 45px;
  font-family: "Palatino Linotype", "Book Antiqua", Palatino, serif;
  overflow: hidden;
  font-size: 12px;
  text-align: center;
}

.card_header_back {
  padding: 5px;
  color: #000;
  height: 65px;
  font-family: "Palatino Linotype", "Book Antiqua", Palatino, serif;
  overflow: hidden;
  font-size: 12px;
  text-align: center;
}

.font_name {
  font-size: 19px;
  margin-left: 0px;
  font-weight: bold;
  font-family: "Palatino Linotype", "Book Antiqua", Palatino, serif;
}

.font_name_back {
  font-size: 18px;
  margin-left: 0px;
  font-weight: bold;
  font-family: "Palatino Linotype", "Book Antiqua", Palatino, serif;
  color: #000;
}

.id_title {
  background-color: "teal";
  height: 20px;
  width: 160px;
  margin-top: 0px;
  border-radius: 0% 0% 100px 100px;
  font-family: "Palatino Linotype", "Book Antiqua", Palatino, serif;
  font-weight: bold;
  text-align: center;
  font-size: 13px;
  margin-left: 30%;
  padding: 2px;
  color: #ffffff;
  margin-bottom: 5px;
  z-index: 100;
}

.id_title_back {
  height: 20px;
  width: 140px;
  margin-top: 0px;
  border-radius: 0% 0% 100px 100px;
  font-family: "Palatino Linotype", "Book Antiqua", Palatino, serif;
  font-weight: bold;
  text-align: center;
  font-size: 13px;
  margin-left: 33%;
  padding: 2px;
  color: #000;
  margin-bottom: 0px;
}

.card_footer {
  border-width: 2px 0px 0px 0px; //1px 0px 0px 0px
  border-color: #bdc3c7;
  border-style: none;
  overflow: hidden;
  height: 25px;
  font-size: 13px;
}

.id_field {
  background-color: #bdc1cb;
  width: 20px; //80px
  font-size: 13px;
  font-weight: bold;
  float: left;
  padding: 1px 1px 1px 1px;
  text-align: left;
  margin-right: 5px;
  display: block;
}

.inf {
  width: 100px;
  font-size: 16px;
  font-weight: bold;
  padding: 1px 1px 1px 1px;
}

.inf-tel {
  width: 100px;
  font-size: 16px;
  font-weight: bold;
  padding: 1px 1px 1px 1px;
}

.barcode {
  text-align: center;
  height: 25px;
  width: 200px;
  margin-top: 5px;
}

.barcode_div {
  border-style: solid;
  border-width: 1px 0px 0px 0px;
  border-color: #bdc1cb;
  padding-top: 5px;
}

.id_box_body {
  height: 175px;
  margin-bottom: 0px;
  overflow: hidden;
}

.name_field {
  margin-bottom: 3px;
}
.card_logo {
  height: 50px;
  width: 50px;
  border-radius: 10%;
  /* background-color: 'teal'; */
}
</style>